import { render } from "./HeroiconsOutlineSaveAs.vue?vue&type=template&id=347525da"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSaveAs.vue"]])

export default __exports__